import styled, { css } from "styled-components";
import { pxToRem } from "../../../utils/pxToRem";

export const Container = styled.div`
  ${({ theme: { padding } }) => css`
    padding: ${padding.primary} 0;
    width: 100%;

    h1 {
      text-align: center;
    }

    @media (max-width: 500px) {
      padding: ${padding.mobile} 0;
    }
  `}
`;

export const Form = styled.form`
  width: 100%;
  max-width: ${pxToRem(840)};
  margin: 0 auto;
`;

export const GridWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 32px 16px;
  margin-bottom: 3rem;
  grid-template-areas: "switch switch" "nome nome" "telefone cep" "rua rua" "numero complemento" "bairro bairro" "uf cidade" "button button";

  > :nth-child(1) {
    grid-area: switch;
    width: fit-content;
    margin: 0 auto;
  }

  > :nth-child(2) {
    grid-area: nome;
  }

  > :nth-child(3) {
    grid-area: telefone;
  }

  > :nth-child(4) {
    grid-area: cep;
  }

  > :nth-child(5) {
    grid-area: rua;
  }

  > :nth-child(6) {
    grid-area: numero;
  }

  > :nth-child(7) {
    grid-area: complemento;
  }

  > :nth-child(8) {
    grid-area: bairro;
  }

  > :nth-child(9) {
    grid-area: uf;
  }

  > :nth-child(10) {
    grid-area: cidade;
  }

  > :nth-child(11) {
    grid-area: button;

    button {
      margin: 0 auto;
      width: ${pxToRem(168)};
    }
  }

  @media (min-width: 640px) {
    grid-template-columns: repeat(6, 1fr);

    gap: ${pxToRem(32)} ${pxToRem(16)};
    grid-template-areas: ". . switch switch . ." "nome nome nome nome nome nome" "telefone telefone telefone cep cep cep" "rua rua rua rua rua rua" "numero numero numero complemento complemento complemento" "bairro bairro uf uf cidade cidade" ". . button button . .";
  }
`;

export const Info = styled.div`
  margin: 0 auto;
  background: #e8e8e8;
  width: fit-content;
  padding: 1rem;
  color: var(--MAPA6, #20332f);
  font-family: Mulish;
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5rem;

  > span {
    color: red;
  }
`;
